import reader from './reader'
import login from './login'
import privacy from './privacy'
import account from './account'
import contactUs from './contactUs'
import faq from './faq'

export default {
  messages: {
    reader,
    login,
    privacy,
    account,
    contactUs,
    faq
  }
}



// WEBPACK FOOTER //
// ./src/locale/en-US/index.js